import { ChangeDetectionStrategy, Component, input, SecurityContext } from '@angular/core';
import { UiCompanyLogoComponent } from '@big-direkt/ui/company-logo';
import { UiPictureModule } from '@big-direkt/ui/picture';
import { PictureModel, SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'big-author-box',
    templateUrl: './author-box.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SanitizePipe, TranslocoPipe, UiPictureModule, UiCompanyLogoComponent],
})
export class AuthorBoxComponent {
    public readonly securityContext: SecurityContext = SecurityContext.HTML;

    public readonly name = input<string>();
    public readonly description = input<string>();
    public readonly image = input<PictureModel>();
}
